import applicationRowContentUrl from './applicantRowContentComponent.html';

export default {
  templateUrl: applicationRowContentUrl,
  controllerAs: 'ctrl',
  bindings: {
    user: '<',
    userUnavailable: '<',
  },
};
